import React, { useContext, useEffect } from 'react';
import * as css from './selectRole.module.scss';
import { LoginApiContext } from '../api/LoginApiContext';
import { useUpdater } from '../api/useUpdater';
import { RoleDto, UserrolesDto } from '../api/generated/login-generated-api';
import { useIntl } from 'react-intl';
import translations from './selectRole.i18n';
import Spinner from '../components/spinner/spinner';
import { useSetDocumentTitle } from '../api/useSetDocumentTitle';
import { groupBy } from '../util';
import { DropdownButton } from '../components/button/dropdownButton';

const SelectRolePage: React.FC<
  React.PropsWithChildren<{ userrolesDto: UserrolesDto }>
> = ({ userrolesDto }) => {
  const { loginApi } = useContext(LoginApiContext);
  useSetDocumentTitle('Velg rolle - Arbeidslivsportalen', []);
  const { doPost, posting } = useUpdater(() => {
    window.location.reload();
  });
  const { selectedRole } = userrolesDto;
  const possibleRoles = userrolesDto.possibleRoles || [];

  const selectUserRole = async (roleDto: RoleDto) => {
    doPost(async () => await loginApi.userrolePost({ roleDto }));
  };

  useEffect(() => {
    if (possibleRoles && possibleRoles.length === 1 && !selectedRole) {
      selectUserRole(possibleRoles[0]);
    }
  }, [possibleRoles, selectedRole]); // eslint-disable-line react-hooks/exhaustive-deps

  const { formatMessage } = useIntl();

  return (
    <div className={css.selectroleContainer}>
      {posting && <Spinner />}
      {!posting && possibleRoles.length > 1 && (
        <>
          <div data-cy="userAuthenticatedLanding">
            <h2 className={css.header}>
              {formatMessage({ id: translations.header.id })}:
            </h2>
            {Object.entries(groupBy(possibleRoles, (v) => v.type)).map(
              ([type, brukere], i) => (
                <DropdownButton
                  key={`tilganger-${i}`}
                  id={'tilganger'}
                  btnText={type}
                  options={brukere.map((value: RoleDto) => ({
                    text: value.name || '',
                    onChange: () => selectUserRole(value),
                  }))}
                />
              ),
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SelectRolePage;
